import { render } from "./LoaderScreen.vue?vue&type=template&id=36cafbdc&scoped=true"
import script from "./LoaderScreen.vue?vue&type=script&lang=js"
export * from "./LoaderScreen.vue?vue&type=script&lang=js"

import "./LoaderScreen.vue?vue&type=style&index=0&id=36cafbdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cafbdc"]])

export default __exports__